import ApiService from './api.service.js'
import { isConstructorDeclaration } from 'typescript'

function buildProjectInfoBodyParams (data) {
  let projectInfoFields = ['OppReg_Id', 'Registration_Id', 'Contact_Id', 'Requestor_Id', 'SFDC_Id', 'Workload_Title', 'Campaign_Name', 'Solution_Business_Segment','Is_Glacier', 'VMware_Workload', 'VMware_License', 'VMware_Cust_Deploy', 'Workload_type', 'Workload_Type_Date_Change', 'PPA_Attestation', 'Root_Access', 'DXC_Managed_Services', 'SaaS', 'Initiate_Account_Flag', 'Workload_Services_Storage', 'Workload_Services_Database', 'Workload_Services_App_services', 'Workload_Services_Compute', 'Workload_Services_Network', 'Projected_Monthly_Spend', 'WL_Overall_Objective', 'WL_Scope_Bounderies', 'WL_App_Transformed', 'WL_Next_Pursuit', 'OppReg_Project_Notes', 'OppReg_Req_Date', 'Workload_Status', 'P_Offering_Agreed', 'Q1', 'Q2', 'Q3', 'Q4', 'Q5', 'Q6', 'Q7', 'Q8', 'Q9', 'Q10', 'Attested_By_Date', 'Attested_By_Email', 'Attested_By_Title', 'Attested_By_Manager', 'Discount_Tier_On_AWS', 'Discount_Tier_On_AWS_2', 'Pricing_Tier_Qualification', 'Attested_By_Date_2', 'Attested_By_Email_2', 'Attested_By_Title_2', 'Attested_By_Manager_2', 'Pricing_Tier_Qualification_2','Scope_of_Work']

  let objBodyParams = { action: 'oppreg-project' }

  for (const property in data) {
    if (projectInfoFields.includes(property) && data[property]) {
      objBodyParams[property] = data[property]
    }
  }
  return objBodyParams
}

function buildWorkloadAnswersBodyParams (data) {
  let workloadAnswersFields = ['Project_Id', 'WL_Q1A', 'WL_Q2A', 'WL_Q3A', 'WL_Q4A', 'WL_Q5A', 'WL_Q6A', 'Attested_By', 'DXC_Services', 'DXC_SA1', 'DXC_SA2', 'WL_Q7A', 'WL_Q8A', 'WL_Q9A', 'WL_Q10A']

  let objBodyParams = { action: 'wl-questions-answer' }

  for (const property in data) {
    if (workloadAnswersFields.includes(property)) {
      objBodyParams[property] = data[property]
    }
  }
  return objBodyParams
}

const oppRegService = {

  register: async function (SFDC_ID, callback) {
    // check if opp exist in our db first
    const oppFound = await this.findOpportunityById(SFDC_ID)
    let oppregParams = {
      params: {
        action: 'oppreg-project',
        SFDC_Id: SFDC_ID
      }
    }
    // let oppregResponse = await ApiService.get(process.env.VUE_APP_OPPREG_API, oppregParams)

    // let workloadStatus = [
    //   'Submitted by User',
    //   'Incomplete/Under Review',
    //   'Submitted to AWS',
    //   'Approved - Tier 1 23% - PPA',
    //   'Approved - Tier 1 23% - PPA SaaS',
    //   'Approved - Tier 3 12%',
    //   'Approved - Tier 2 - Custom EDP',
    //   'Disqualified - AWS forecast conflict',
    //   'Shareshift',
    //   'Disqualified - Incomplete',
    //   'Disqualified - No AWS scope',
    //   'AWS Validated',
    //   'DXC Won',
    //   'LEGACY - Approved - Tier 1 23% - PPA',
    //   'Approved - Tier 1 23% - PPA SaaS',
    //   'Approved - Tier 3 12%',
    //   'Approved - Tier 2 - Custom EDP',
    // ]

    // let oppregByStatus =  oppregResponse.data.filter(account => workloadStatus.includes(account.Workload_Status))
    // console.log('Oppreg by Status', oppregByStatus)

    if (oppFound) {
      callback(null, {
        recordExist: true,
        message: `Opportunity <b>${SFDC_ID}</b> has already been submitted.`
      })
      return
    }

    let resData = {
      opportunity: null,
      account: null
    }
    let oppResponse = await this.findOpportunityBySfId(SFDC_ID)
    // Currently the EDL endpoint that we connect to sometimes throw connection timeout 504 error due to slow response in the api service that we connect
    // Solution for now is handle the error on the UI
    if (oppResponse == 504) {
      callback(null, { timeOutError: true, message: 'Connection Timeout Error. The service connection to pull in Salesforce Opportunity ID information is not responding.' })
    } else {
      if (!oppResponse.data || oppResponse.data == 'Opportunity Id does not exist!') {
        callback(oppResponse.data, { recordNotFound: true, message: 'Salesforce ID not valid. Please check your Oppty ID and eliminate any spaces in the entry. Please allow for 24 hours to batch any newly created Salesforce Opportunity IDs into this Galaxy OppReg tool for validation.' })
      } else {
        resData['opportunity'] = oppResponse.data
        callback(resData)
      }
    }
  },

  findOpportunityBySfId: async function (id) {
    // try {
      let reqParams = {
        params: {
          client_ID: id,
          Requestor_Id: vm.$store.state.currentUser.email
        }
      }
      // let oppResponse = await ApiService.get(process.env.VUE_APP_SALESFORCE_REGISTER_API, reqParams)
      let oppResponse = await ApiService.get(process.env.VUE_APP_DATALAKE_API, reqParams)
      console.log('------- DATALAKE RESPONSE -------')
      console.log(oppResponse)
      console.log('------------------------------------------------------')
      return oppResponse

    // } catch (error) {
    //   vm.$store.commit('validatingOppId', true)
    // }
  },

  findOpportunityById: async function (id) {
    console.log('findOpportunityId: '+  id)
    let oppParams = {
      params: {
        action: 'oppreg-info',
        Opportunity_Id: id
      }
    }

    let oppCheckResponse = await ApiService.get(process.env.VUE_APP_OPPREG_API, oppParams)
    console.log('---------- oppCheckResponse -----------')
    console.log(oppCheckResponse)
    console.log('---------------------------------------')
    return oppCheckResponse.data.length > 0 ? oppCheckResponse.data[0] : false
  },

  generateId: async function (type, callback) {
    let actionName 
    if(type === 'internal') {
      actionName = 'custom-dxcint-sequence'
    } else if (type ==='subsidiary') {
      actionName = 'custom-dxcsub-sequence'
    } else if (type === 'gainwell') {
      actionName = 'custom-dxcgnw-sequence'
    }
    let postParamsBody = {
      action: actionName,
      id: null
    }
    let postResponse = await ApiService.post(process.env.VUE_APP_OPPREG_API, postParamsBody)
    if (postResponse.data.length) {
      callback(postResponse.data[0])
    }
  },

  oppSubmit: async function (formData, callback) {  
    let responses = {
      requestor: formData['requestor'],
      contact: null,
      opportunity: null,
      account: null,
      header: null
    }
    
    let custGetParams = {
      params: {
        action: 'check-customer-region',
        Customer_Name: formData.oppFields.account.Customer_Name,
        Customer_Region: formData.oppFields.account.Customer_Region
      }
    }
    let custResponse = await ApiService.get(process.env.VUE_APP_OPPREG_API, custGetParams)
    
    formData.oppFields.account['Customer_Id'] = custResponse.data.id

    delete formData.oppFields.account['Cust_Region']
    delete formData.oppFields.account['Customer_Name']
    delete formData.oppFields.account['Customer_Region']

    let oppExternalBody = {
      action: 'external',
      ...formData.oppFields['account']
    }
    
    let accountPostResponse = await ApiService.post(process.env.VUE_APP_OPPREG_API, oppExternalBody)
    
    if (accountPostResponse.data) {
      formData.oppFields.account = {
        id: accountPostResponse.data.id,
        ...formData.oppFields['account']
      }
    }
  
    let oppregHeaderBody = {
      action: 'submit-oppreg',
      OppReg_Id: formData.oppFields.opportunity.Opportunity_Id,
      Requestor_Id: formData.oppFields.requestor.Requestor_Id,
      Opportunity_Id: formData.oppFields.opportunity.Opportunity_Id,
      Ext_Account_Id: formData.oppFields.account.id,
      OppReg_Header_Notes: formData.oppFields.header.Oppreg_Header_Notes,
      RFI_RFP: formData.oppFields.header.RFI_RFP,
      OppReg_Status: 'Submitted by User',
      Country: formData.oppFields.opportunity.Country,
      SFDC_Id: formData.oppFields.opportunity.Opportunity_Id,
      Client_ID: formData.oppFields.opportunity.Client_ID,
      ContractLength: formData.oppFields.opportunity.ContractLength,
      Customer_Name: formData.oppFields.opportunity.Customer_Name,
      ESRegion: formData.oppFields.opportunity.ESRegion,
      IndustryVertical: formData.oppFields.opportunity.IndustryVertical,
      IndustryVerticalOther: formData.oppFields.opportunity.IndustryVerticalOther,
      NatSec: formData.oppFields.opportunity.NatSec,
      Global_Registered: formData.oppFields.opportunity.Global_Registered,
      OpportunityDescription: formData.oppFields.opportunity.OpportunityDescription,
      OpportunityStatus: formData.oppFields.opportunity.OpportunityStatus,
      OpportunityTotalValueUSD: formData.oppFields.opportunity.OpportunityTotalValueUSD,
      Opportunity_Id: formData.oppFields.opportunity.Opportunity_Id,
      PrimaryESPracticeName: formData.oppFields.opportunity.PrimaryESPracticeName,
      SFDC_Oppty_Name: formData.oppFields.opportunity.SFDC_Oppty_Name,
      SFDC_Sales_Stage: formData.oppFields.opportunity.SFDC_Sales_Stage,
      SignDate: formData.oppFields.opportunity.SignDate,
      Owner_Email: formData.oppFields.opportunity.Owner_Email,
      Owner_Name: formData.oppFields.opportunity.Owner_Name
    }
    
    let oppregHeaderResponse = await ApiService.post(process.env.VUE_APP_OPPREG_API, oppregHeaderBody)
    if (oppregHeaderResponse.data) {
      responses.header = oppregHeaderResponse.data
    }
    
    callback(responses)
  },

  workLoadSubmit: async function (workloadData, callback) {
    let oppregProjectBody = buildProjectInfoBodyParams(workloadData)
    let oppregProjectResponse = await ApiService.post(process.env.VUE_APP_OPPREG_API, oppregProjectBody)
    if (oppregProjectResponse.data.id) {
      // insert record to WL_Questions_Answer
      let oppregWorkloadAnswerBody = buildWorkloadAnswersBodyParams({ ...workloadData, Project_Id: oppregProjectResponse.data.id })
      
      let oppregWorkloadAnswerBodyResponse = await ApiService.post(process.env.VUE_APP_OPPREG_API, oppregWorkloadAnswerBody)
      if (oppregWorkloadAnswerBodyResponse.data) {
        callback(oppregProjectResponse.data.id)
      }
    } else {
      callback(null, { error: true })
    }
  },

  submitMultipleWorkload: async function (strWorkloadIds, workloads, callback) {
    let multipleSubmitPostBody = {
      action: 'submit_workloads',
      Project_Ids: strWorkloadIds
    }
    let multiplePostResponse = await ApiService.put(process.env.VUE_APP_MULTIPLE_WORKLOAD_SUBMIT_API, multipleSubmitPostBody)
    if (multiplePostResponse.data) {
      workloads.forEach(workload => this.sendEmailToSubmmitter(workload))
      callback(multiplePostResponse.data)
    }
  },

  submitAllWorkload: async function (opportunityId, workloads, callback) {
    // TODO: Need api to set the status of all workload related to this opportunityId to submitted, for now let's send an email thru api
    let multipleRelatedWorkloadPostBody = {
      action: 'submit_workloads',
      OppReg_Id: opportunityId,
      Requestor_Id: vm.$store.state.currentUser.requestor_id
    }
    let multiplePostResponse = await ApiService.put(process.env.VUE_APP_MULTIPLE_RELATED_WORKLOAD_SUBMIT_API, multipleRelatedWorkloadPostBody)
    if (multiplePostResponse.data) {
      // send email for each workload
      workloads.forEach(workload => this.sendEmailToSubmmitter(workload))
      callback(multiplePostResponse.data)
    }
  },
  // AGAM-1276 - Disables Product Offering Verified email
  // sendSfdcVerificationEmail: async function (id, callback) {
  //   try {
  //     // setup email params
  //     let emailPostBody = {
  //       send_to: vm.$store.state.currentUser.email,
  //       oppreg_id: id,
  //       template: 'product-offering-agreed',
  //       Attested_by: vm.$store.state.currentUser.name
  //     }
  //     let emailPostResponse = await ApiService.post(process.env.VUE_APP_GALAXY_MAIL_SERVER_API, emailPostBody)
  //     if (emailPostResponse.result) {
  //       console.log('an email has been sent')
  //       // callback(emailPostResponse.result)
  //     }
  //     // callback(null, { error: true, message: 'Failed to generate email notification. Please contact administrator' })
  //   } catch (error) {
  //     // error
  //     console.log('error here')
  //   }
  // },

  sendEmailToSubmmitter: async function (workload, callback) {
    // get email of the related contact
    let contactParams = {
      params: {
        action: 'contact-info',
        Id: workload.Contact_Id
      }
    }
    let contactResponse = await ApiService.get(process.env.VUE_APP_REQUEST_AWS_ACCOUNT, contactParams)
    if (contactResponse.data.length) {
      console.log('contact email: ' + contactResponse.data[0].Contact_Email)
      console.log('registration id: '+ workload.Registration_Id)
      let emailPostBody = {
        send_to: contactResponse.data[0].Contact_Email, // target recipient(s) separated by comma(,)
        oppreg_id: workload.Registration_Id, // opportunity id
        template: 'submitter'
      }
      let emailPostResponse = await ApiService.post(process.env.VUE_APP_GALAXY_MAIL_SERVER_API, emailPostBody)
      if (!emailPostResponse.data.result) {
        callback(null, { error: true, message: 'Failed to generate email notifications. Please contact administrator' })
        // handle error
      }
    }
  },

  updateWorkload: async function (data, callback) {
    let oppregProjectBody = buildProjectInfoBodyParams(data)
    // currently theres an error with the update query on where clause part,
    let oppregProjectResponse = await ApiService.put(process.env.VUE_APP_OPPREG_API, oppregProjectBody, { params: { action: 'oppreg-project', Registration_Id: data.Registration_Id } })
    if (oppregProjectResponse.data) {
      let oppregWorkloadAnswerBody = buildWorkloadAnswersBodyParams(data)
      let oppregWorkloadAnswerBodyResponse = await ApiService.put(process.env.VUE_APP_OPPREG_API, oppregWorkloadAnswerBody)
      if (oppregWorkloadAnswerBodyResponse.data) {
        if (data.Workload_Status === 'Submitted by User') {
          this.sendEmailToSubmmitter(data)
        }
        callback(oppregProjectResponse)
      }
    }
  },

  submitDiscount: async function (data, callback) {
    let oppregProjectBody = buildProjectInfoBodyParams(data)

    let oppregProjectResponse = await ApiService.put(
      process.env.VUE_APP_OPPREG_API, oppregProjectBody, { 
        params: { action: 'oppreg-project', Registration_Id: data.Registration_Id } })
    if (oppregProjectResponse.data) {
      callback(oppregProjectResponse)
    } else {
      callback(null, {error: 'Failed Updating Discount'})
    }
  },

  getWorkloadsByOppId: async function (opportunityId, callback) {
    const oppFound = await this.findOpportunityById(opportunityId)
    if (!oppFound) {
      // if not found, let's check if this sfdc id exist in salesforce
      let reqSfParams = {
        params: {
          client_ID: opportunityId
        }
      }
      let sfResponse = await ApiService.get(process.env.VUE_APP_SALESFORCE_REGISTER_API, reqSfParams)
      if (sfResponse.data === null) {
        callback(null, { opportunityFound: false, message: 'Invalid Opportunity Id' })
      } else {
        callback(null, { opportunityFound: true })
      }
    } else {
      let projectParams = {
        params: {
          get_records: 'list',
          SFDC_Id: opportunityId
          // Requestor_Id: vm.$store.state.currentUser.requestor_id
        }
      }
      let oppregResponse = await ApiService.get(process.env.VUE_APP_WORKLOAD_API, projectParams)
      if (oppregResponse.data.length) {
        // eslint-disable-next-line standard/no-callback-literal
        callback({ id: opportunityId, workloads: oppregResponse.data })
      } else {
        // eslint-disable-next-line standard/no-callback-literal
        callback({ noWorkloadsFound: true, id: opportunityId, message: 'No workloads has been registered yet for this opportunity.' })
      }
    }
  },

  retrieveOppregRequestWithNoDiscounts: async function (params, callback) {
    // call an api to check if opx is connected to account

    // try {
    //   let reqParams = {
    //     params: {
    //       action: 'onboarding',
    //       Registration_Id: id
    //     }
    //   }
    //   let onboardingResponse = await ApiService.get(process.env.VUE_APP_ACCINVENTORY_API, reqParams)
    //   if (onboardingResponse.data.length) {
    //     callback(null, { acctExist: true, data: onboardingResponse.data })
    //   } else {
    //     // eslint-disable-next-line standard/no-callback-literal
    //     callback(null, {acctExist: false, data: onboardingResponse.data })
    //   }
    // } catch (error) {
    //   vm.$store.commit('setAccountIdExistLoading', false)
    // }

    // if yes
    // throw an error that account already exist

    // if no
    // get the details of the record
    console.log(params)
    let requestParams = {
      params: {
        Opportunity_Id: params['sfdcId']
      }
    }

    let oppregResponse = await ApiService.get(process.env.VUE_APP_OPPREG_REQUEST_API, requestParams)
    if (oppregResponse.data.data_result && oppregResponse.data.data_result.length === 1) {

      let reqParams = {
        params: {
          action: 'onboarding',
          Project_Id: oppregResponse.data.data_result[0].Project_Id
        }
      }

      let onboardingResponse = await ApiService.get(process.env.VUE_APP_ACCINVENTORY_API, reqParams)
      console.log('onboardingResponse: ', onboardingResponse)
      if (onboardingResponse.data.length) {
        callback(null, { acctExist: true, message: 'Account Exist!' })
      } else {
        callback({ OppRegRequestsData: oppregResponse.data.data_result })
      }
    } else {
      callback(null, {noRecordFound: true, message: 'No recourd found. You must first register the opportunity'})
    }
  },

  retrieveOppRegRequests: async function (params, callback) {
    let requestParams = {
      params: {
        from_date: params['to_date'],
        to_date: params['to_date'],
        Opportunity_Id: params['sfdcId'],
        Customer_Name: params['Customer_Name'],
        ESRegion: params['ESRegion'],
        Workload_Status: params['Workload_Status'],
        Requestor_Id: params['Requestor_Id'],
        Type_Initiative: params['typeInitiative']
      }
    }
    if (params['Requestor_Email']) {
      requestParams.params.Requestor_Email = params['Requestor_Email']
    }
    if (params['AWS_ACE_ID']) {
      requestParams.params.AWS_ACE_ID = params['AWS_ACE_ID']
    }
    // try {
      let oppregResponse = await ApiService.get(process.env.VUE_APP_OPPREG_REQUEST_API, requestParams)

      if (oppregResponse.data && oppregResponse.data.length) {
        callback({ OppRegRequestsData: oppregResponse.data })
      } else {
        callback(null, {noRecordFound: true, message: 'No recourd found. You must first register the opportunity'})
      }

      
    // } catch (error) {
    //   vm.$store.commit('showWorkloadSearching', { searching: false })
    // }
  },

  getOppRegRequests: async function (params, callback) {
    let requestParams = {
      params: {
        from_date: params['from_date'],
        to_date: params['to_date'],
        Opportunity_Id: params['sfdcId'],
        Customer_Name: params['Customer_Name'],
        ESRegion: params['ESRegion'],
        Workload_Status: params['Workload_Status'],
        Requestor_Id: params['Requestor_Id'],
        Type_Initiative: params['typeInitiative'],
        size: params['size'] ? params['size'] : 10
      }
    }
    if (params['Requestor_Email']) {
      requestParams.params.Requestor_Email = params['Requestor_Email']
    }
    if (params['nextPageKey']) {
      requestParams['params']['nextPageKey'] = params['nextPageKey']
    }
    if (params['AWS_ACE_ID']) {
      requestParams['params']['AWS_ACE_ID'] = params['AWS_ACE_ID']
    }
    // try {
      let oppregResponse = await ApiService.get(process.env.VUE_APP_OPPREG_REQUEST_API, requestParams)
      if (oppregResponse.data && oppregResponse.data.data_result.length) {
        callback({ OppRegRequestsData: oppregResponse.data })
      } else {
        callback(null, { noRecordFound: true, message: 'No recourd found. You must first register the opportunity' })
      }
    // } catch (error) {
    //   vm.$store.commit('showWorkloadSearching', { searching: false })
    // }
  },
  validateRegistrationId: async function (registrationId, callback) {
    let oppregReqParams = {
      params: {
        action: 'oppreg-project',
        Registration_Id: registrationId
      }
    }
    let oppregProjectResponse = await ApiService.get(process.env.VUE_APP_OPPREG_API, oppregReqParams)
    if (oppregProjectResponse.data.length) {
      callback(null, { duplicateTitle: true })
    } else {
      callback(oppregProjectResponse.data)
    }
  }
}

export default oppRegService
